/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineRecipe } from '@chakra-ui/react';

export const radiomark = defineRecipe({
  className: 'chakra-radiomark',
  base: {
    '& .dot': {
      _dark: {
        scale: '0.7',
      },
    },
  },

  variants: {
    variant: {
      solid: {
        _dark: {
          _checked: {
            bg: 'link',
            color: 'colorPalette.contrast',
            borderColor: 'link',
          },
          bg: 'white',
          color: 'colorPalette.contrast',
          borderColor: 'gray.400',
          _disabled: {
            bg: 'gray.200',
            color: 'gray.100',
            borderColor: 'gray.200',
          },
        },
      },
    },

    size: {
      xs: {
        boxSize: '3',
      },

      sm: {
        boxSize: '4',
      },

      md: {
        boxSize: '5',
      },

      lg: {
        boxSize: '6',
      },
    },

    filled: {
      true: {
        bg: 'bg',
      },
    },
  },

  defaultVariants: {
    variant: 'solid',
    size: 'lg',
  },
});
